import { useState } from "react";
import DialogComponent from "./Dialog";
import { appUrl, post, slugify } from "../../utils/fetch";
import { useDispatch } from "react-redux";
import Cookies from 'js-cookie';
import './AIDialog.css';

export default function AIDialog(props) {
    const {
        label,
        isOpen,
        setIsOpen,
        field,
        model,
        id,
        original,
        dispatchFunc,
        slugField,
        handleSubmit
    } = props;

    const dispatch = useDispatch();

    const initContent = `Generate "${label}" with AI?`;

    const [ isLoading, setIsLoading ] = useState(false);
    const [ content, setContent ] = useState(initContent);
    const [ isGenerated, setIsGenerated ] = useState(false);
    const [ value, setValue ] = useState("");

    const tokens = Cookies.get('tokens') || 0;

    const closeDialog = () => {
        setIsOpen(false);
        setIsLoading(false);
        setContent(initContent);
        setIsGenerated(false);
    }

    const generate = () => {
        post(
            `${appUrl}/api/ai/generate`,
            { field, model, id },
            (response) => {
                setIsLoading(false);
                if (response?.data?.data) {
                    Cookies.set('tokens', response.data.tokens_left);
                    setContent((
                        <div>
                            Original {label}:<br/>
                            <b>{original}</b>
                            <br/><br/>
                            AI Generated {label}:<br/>
                            <b>{response.data.data}</b>
                        </div>
                    ));
                    setIsGenerated(true);
                    setValue(response.data.data);
                } else {
                    if(response?.data?.message){
                        setContent(`Error: ${response.data.message}`);
                    } else {
                        setContent("Error generating content. Please try again.");
                    }
                }
            },
            () => {
                setIsLoading(true);
                setContent((<center>Generating...</center>));
            }
        )
    }

    const apply = () => {
        dispatch(dispatchFunc({ [field]: value }));
        if (slugField) {
            dispatch(dispatchFunc({ [slugField]: slugify(value) }));
        }
        closeDialog();
    }

    const applyAndSave = () => {
        if (handleSubmit) {
            handleSubmit({
                [field]: value,
                ...(slugField ? { [slugField]: slugify(value) } : {})
            });
            closeDialog();
        }
    }

    return (
        <DialogComponent
            onClose={closeDialog}
            open={isOpen}
            isLoading={isLoading}
            content={(
                <div className="ai-dialog-content">
                    <div className="ai-tokens">
                        Tokens available: <b>{tokens}</b>
                    </div>  
                    {content}
                </div>
            )}
            buttons={[
                ...(isGenerated ? [
                    {
                        variant: "text",
                        label: "Apply",
                        onClick: apply
                    },
                    {
                        variant: "text",
                        label: "Apply & Save",
                        onClick: applyAndSave
                    }
                ] : []),
                {
                    variant: "contained",
                    label: isGenerated ? "Retry" : "Generate",
                    onClick: generate,
                },
                {
                    variant: "outlined",
                    label: "Cancel",
                    color: "secondary",
                    onClick: closeDialog
                }
            ]}  
        />
    );
}